import { useQuery } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CARE_SOURCE } from '../constants';
import { CareSuccess, ReadinessReport } from '../types';
import { CARE_READINESS_KEY, careBillingUrl } from './constants';
import useCareScope from './useCareScope';

// Takes the month lock and may call Commerce, so it runs only on demand (refetch), never on page load.
const useCareReadiness = (month: string) => {
    const req = useRequest();
    const orgId = useCareScope();

    const request = () =>
        req<CareSuccess<ReadinessReport>>({
            url: `${envVars.API_RTM_HOSTNAME}${careBillingUrl('month/readiness/')}`,
            query: { month, source: CARE_SOURCE }
        }).then((response) => response.data);

    return useQuery({
        queryFn: request,
        queryKey: [CARE_READINESS_KEY, orgId, month],
        enabled: false,
        retry: false
    });
};

export default useCareReadiness;
